import { render } from "./RecommendationsCard.vue?vue&type=template&id=e2d68fd8"
import script from "./RecommendationsCard.vue?vue&type=script&lang=js"
export * from "./RecommendationsCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__